// only act as a reference point to gather localizations
// register create function for bundleid
Oskari.bundle('lounaistieto-lang-overrides', function () {
  return {
    start: function start() {/* no-op */},
    stop: function stop() {/* no-op */}
  };
});